import { z } from 'zod';
import { OpenedDtoChannel } from '../../generated/openapi/safety-check';

export const channel = z.enum(OpenedDtoChannel);

const opened = z.object({
  openedAt: z.coerce.date().optional(),
  channel: channel.optional(),
});

export default opened;

export type Opened = z.infer<typeof opened>;
